import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    width: '100vw',
    height: '100svh'
  },

  bgHolder: {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    width: '100%',
    height: '100%',

    '& .bg': {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%'
    }
  },

  box: {
    position: 'absolute',
    border: '1px solid #e9e9e9',
    top: '25%',
    left: '40%',
    width: '25%',
    minHeight: '40%',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 10px 5px 0 rgba(11, 11, 11, 0.2)',
    padding: '2.18rem 1.82rem 1.58rem 1.82rem',
    background: 'white',
    opacity: '50%'
  },

  info: {
    fontSize: theme.size.base
  },

  back: {
    cursor: 'pointer',
    fontWeight: theme.bold.bold
  }
}))

export default useStyles
